import { ErrorMapper } from "@/core/shared/api/domain/serializers";
import { SendSelfieErrors } from "@/core/portrayal/domain/portrayalErrors";

export const sendSelfieErrorMapper: ErrorMapper = {
  blurred_image_error: { reason: SendSelfieErrors.BlurredImageError },
  document_classification_error: { reason: SendSelfieErrors.DocumentClassificationError },
  validas_error: { reason: SendSelfieErrors.ValidasError },
};
